import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const benefits = [{
  number: '01',
  title: 'Volumizing and Lifting',
  description: 'PDO threads are particularly effective for adding volume and lifting sagging skin. They can be strategically placed to lift and contour areas like the cheeks, jawline, and neck, providing a more youthful appearance without the need for invasive surgery.'
}, {
  number: '02',
  title: 'Texture Improvement',
  description: 'For individuals looking to improve the texture of their skin, PDO threads can be an excellent option. They stimulate collagen production, which helps to smooth out rough or uneven skin, making it look more refined and youthful.'
}, {
  number: '03',
  title: 'Acne Scarring',
  description: 'PDO threads can also be used to address acne scarring. By inserting the threads into the skin, they help to break up the scar tissue and promote the formation of new collagen, leading to a reduction in the appearance of scars over time.'
}, {
  number: '04',
  title: 'Reducing Lines and Wrinkles',
  description: "Fine lines and wrinkles can be effectively treated with PDO threads. The threads create a scaffold under the skin, providing support and stimulating the body's natural healing processes. This results in a reduction of wrinkles and a smoother complexion."
}, {
  number: '05',
  title: 'Non-Surgical Face Lifting',
  description: 'One of the most popular uses of PDO threads is for non-surgical face lifting. They offer a minimally invasive alternative to traditional face lifts, with significantly less downtime. The threads are inserted into the skin to lift and tighten areas like the mid-face, jawline, and neck, delivering immediate and long-lasting results.'
}];
export function PTBenefits() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1720">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-1721">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-1722">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-1723">
            Be BOLD
          </span>

          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1724">
            TOP 5 BENEFITS & APPLICATIONS
          </h2>

          <p className="text-[#333333] text-[17px] leading-[1.7] font-body max-w-[800px] mb-6" data-id="element-1725">
            PDO threads come in multiple forms and can be employed for various
            purposes, including volumizing, improving texture, treating acne
            scarring, reducing lines and wrinkles, and performing non-surgical
            face lifting.
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-1726"></div>
        </AnimateOnScroll>

        <div className="max-w-[900px] mx-auto" data-id="element-1727">
          {benefits.map((benefit, index) => <AnimateOnScroll key={index} delay={index * 100} data-id="element-1728">
              <div className={`py-8 ${index < benefits.length - 1 ? 'border-b border-[#CCCCCC]' : ''}`} data-id="element-1729">
                <div className="flex flex-col lg:flex-row items-start gap-6" data-id="element-1730">
                  <span className="text-[#FF1493] text-[72px] font-[700] font-[Poppins,_sans-serif] opacity-20 leading-none flex-shrink-0 lg:w-[100px]" data-id="element-1731">
                    {benefit.number}
                  </span>
                  <div className="flex-1" data-id="element-1732">
                    <h3 className="text-black text-xl lg:text-[22px] font-bold font-[Poppins,_sans-serif] mb-3" data-id="element-1733">
                      {benefit.title}
                    </h3>
                    <p className="text-[#333333] text-base leading-[1.7] font-body" data-id="element-1734">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}